import { defineStore } from 'pinia';

export const useFormulaBuilderStore = defineStore('formulaBuilder', {
    state: () => ({
        draggedAttribute: {},
        currentLayout: [],
        currX: 0,
        currY: 0,
        index: 0,
        colNum: 12,
        activeItem: { x: null, y: null, i: null },
    }),
    actions: {
        setDraggedAttribute(attribute) {
            this.draggedAttribute = attribute;
        },
        setActiveItem(item) {
            this.activeItem.x = item.x;
            this.activeItem.y = item.y;
            this.activeItem.i = item.i;
        },
        resetLayout() {
            this.currentLayout = [];
            this.currX = 0;
            this.currY = 0;
            this.index = 0;
            this.activeItem = { x: null, y: null, i: null };
        },
    },
});
